/**
 * Player app deleted view module.
 *
 * @stable
 */

import { NgModule } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

import { BasicModule } from '@shared/modules/basic.module';

import { DeletedView } from '@player/+deleted/deleted.component';
import { BrandWordmark } from '@player/shared/components/brand-wordmark/brand-wordmark.component';

@NgModule({
  bootstrap: [],
  declarations: [DeletedView],
  exports: [],
  imports: [BasicModule, MatIconModule, BrandWordmark],
  providers: [],
})
export class DeletedModule {}
